/* src/app/content-editor/properties-panel/properties-panel.component.scss */
:host {
  --accent: #0c447c;
  --accent-light: #e6f1fb;
  --bg-secondary: #f7f7f5;
  --text-primary: #1a1a1a;
  --text-secondary: #6b6b6b;
  --text-tertiary: #999;
  --border: rgba(0, 0, 0, 0.1);
  --border-hover: rgba(0, 0, 0, 0.2);
  display: contents;
}
.properties-panel {
  width: 490px;
  max-width: min(490px, 100vw - 32px);
  max-height: 80vh;
  overflow-y: auto;
  border: 0.5px solid var(--border);
  padding: 16px;
  background: #fff;
  color: var(--text-primary);
  text-align: left;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  z-index: 1000;
  margin: 0;
}
.properties-panel:popover-open {
  position: fixed;
  inset: auto;
  top: anchor(bottom);
  left: anchor(left);
  margin-top: 8px;
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border);
}
.panel-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.form-control {
  height: 40px;
}
.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 0.5px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  border-radius: 8px;
  padding: 0;
  width: 28px;
  height: 28px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.12s ease;
  white-space: nowrap;
}
.icon-button:hover {
  border-color: var(--border-hover);
  color: var(--text-primary);
}
.close-btn {
  cursor: pointer;
  color: var(--text-tertiary);
}
.item-name {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 12px;
}
.properties-panel input.form-control,
.properties-panel select.form-control {
  width: 100%;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text-primary);
  padding: 10px 12px;
  font-size: 13px;
  outline: none;
}
.properties-panel input.form-control:focus,
.properties-panel select.form-control:focus {
  border-color: rgba(12, 68, 124, 0.35);
  box-shadow: 0 0 0 4px rgba(12, 68, 124, 0.08);
}
.properties-editor .prop-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  padding: 4px 0;
}
.properties-editor .prop-row.header {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-secondary);
}
.properties-editor .prop-row .col-key {
  width: 160px;
  flex-shrink: 0;
}
.properties-editor .prop-row .col-val {
  flex: 1;
  min-width: 0;
}
.properties-editor .prop-row .col-action {
  width: 20px;
  text-align: center;
}
.suggested-properties {
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
  padding: 10px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: var(--bg-secondary);
}
.suggested-properties-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.suggested-property-row {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr) 32px;
  gap: 8px;
  align-items: center;
}
.suggested-property-key,
.suggested-property-value {
  min-width: 0;
  font-size: 12px;
  color: var(--text-secondary);
}
.suggested-property-key {
  font-weight: 600;
}
.suggested-property-add {
  width: 32px;
  height: 32px;
  padding: 0;
}
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.no-props {
  font-style: italic;
  color: var(--text-tertiary);
  margin-bottom: 10px;
}
.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
/*# sourceMappingURL=properties-panel.component.css.map */
